import * as R from 'ramda';
import {
  JobItem,
  JobQueryType,
  JobQueryVariableType,
} from '@/appsync/graphql/job';
import { getJobsByTenantLandscape } from '@/appsync/graphql/job';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';
import { getSHA3OfTenantLandscape } from '@/utils/CommonUtils';
import { sortTasksByOrder } from '@/utils/JobUtils';

const _fetchJobs = async (tenantLandscape: string): Promise<JobItem[]> => {
  const jobItems: JobItem[] = [];
  let isFirstPage = true;
  let nextToken: string | undefined | null = null;

  while (isFirstPage || nextToken) {
    isFirstPage = false;
    const variables: JobQueryVariableType = {
      tenantLandscape,
      nextToken,
    };
    const result = await graphqlQuery<JobQueryType, JobQueryVariableType>(
      getJobsByTenantLandscape,
      variables
    );

    const fetchedJobItems: JobItem[] | undefined = R.path(
      ['jobsByTenantLandscape', 'items'],
      result
    );
    if (fetchedJobItems) {
      jobItems.push(...sortTasksByOrder(fetchedJobItems));
    }

    nextToken = R.path(['jobsByTenantLandscape', 'nextToken'], result);
  }
  return jobItems;
};

export const fetchJobs: (
  tenant: string,
  landscape: string
) => Promise<JobItem[]> = R.pipe(getSHA3OfTenantLandscape, _fetchJobs);
